var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"cover_image","src":require("../assets/chickenvesuvio.jpg"),"alt":"recipe image "}})])}]

export { render, staticRenderFns }